<template>
  <div>
    <v-btn
      id="openFilter"
      outlined
      color="white"
      @click="dialog = true"
    >
      <v-icon color="primary">
        mdi-filter-variant
      </v-icon>
      <span class="button secondary500">Exportar</span>
    </v-btn>
    <sidebar-dialog
      v-model="dialog"
      title="Exportar Qrcodes"
    >
      <v-form
        ref="filterTemplateForm"
        class="fill-height"
        @submit.prevent="confirmTerminate()"
      >
        <div class="d-flex flex-column justify-space-between fill-height">
          <v-row>
            <v-col cols="12">
              <v-row>
                <v-col
                  cols="12"
                  class="pt-6"
                >
                  <span>Data da criação</span>
                  <v-row class="pt-2">
                    <v-col cols="6">
                      <input-date
                        id="input:minCreatedAt"
                        v-model="payload.minCreatedAt"
                        :rules="[dateLesserThan(payload.maxCreatedAt)]"
                        label="Inicial"
                      />
                    </v-col>
                    <v-col cols="6">
                      <input-date
                        id="input:maxCreatedAt"
                        v-model="payload.maxCreatedAt"
                        :rules="[dateGreaterThan(payload.minCreatedAt)]"
                        label="Final"
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  class="pt-6"
                >
                  <span>Data da atualização</span>
                  <v-row class="pt-2">
                    <v-col cols="6">
                      <input-date
                        id="input:minUpdatedAt"
                        v-model="payload.minUpdatedAt"
                        :rules="[dateLesserThan(payload.maxUpdatedAt)]"
                        label="Inicial"
                      />
                    </v-col>
                    <v-col cols="6">
                      <input-date
                        id="input:maxUpdatedAt"
                        v-model="payload.maxUpdatedAt"
                        :rules="[dateGreaterThan(payload.minUpdatedAt)]"
                        label="Final"
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  class="pt-6"
                >
                  <input-text
                    id="input:storeId"
                    v-model="payload.storeId"
                    label="ID da loja"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  class="pt-6"
                >
                  <input-text
                    id="input:clientId"
                    v-model="payload.clientId"
                    label="ID do cliente"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  class="pt-6"
                >
                  <input-text
                    id="input:sgvClientId"
                    v-model="payload.sgvClientId"
                    label="ID SGV"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-spacer />
          <v-btn
            id="submitFilter"
            color="primary"
            height="48px"
            type="submit"
            :loading="loading"
          >
            <span class="button">Exportar</span>
          </v-btn>
        </div>
      </v-form>
    </sidebar-dialog>
  </div>
</template>

<script>
import RulesMixin from '@/app/arch/mixins/RulesMixin';
import SidebarDialog from '@/app/arch/template/SidebarDialog.vue';
import ReportConfirmMangerModalVue from '@/app/arch/components/modals/ReportConfirmMangerModal.vue';
import QrcodeRequest from './QrcodeRequest';

export default {
  name: 'QrcodeFilter',
  components: { SidebarDialog },
  extends: ReportConfirmMangerModalVue,
  mixins: [RulesMixin],
  data: () => ({
    requestClass: QrcodeRequest,
    dialog: false,
    payload: {
      storeId: '',
      clientId: '',
      sgvClientId: '',
      fromExistingQrCode: '',
      minCreatedAt: '',
      maxCreatedAt: '',
      minUpdatedAt: '',
      maxUpdatedAt: '',
    },
    successMessage: 'Qrcodes exportados com sucesso!',
    crudListName: 'QrcodeList',
  }),
  computed: {
    proxyRequest() {
      return () => this.requestClass.solicit({
        request: {
          ignorePagination: true,
          reportType: 'Csv',
        },
        filter: {
          ...Object.keys(this.payload)
            .reduce(
              (obj, key) => {
                const override = { ...obj };
                const item = this.payload[key];
                if (this.isValidValue(item)) {
                  override[key] = item;
                }

                return override;
              },
              {},
            ),
        },
      });
    },
  },
};
</script>
